import React, { useEffect, useState } from 'react';
import api from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Card, CardContent } from '../components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../components/ui/table';
import { Search, Loader2, Eye } from 'lucide-react';
import { formatDateID } from '../lib/format';
import { useNavigate } from 'react-router-dom';
import { CHANNEL_LABEL_ID } from '../lib/constants';

export default function FollowUps() {
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get('/followups');
      const filtered = !search ? data : data.filter(f => (f.client_name || '').toLowerCase().includes(search.toLowerCase()) || (f.invoice_number || '').toLowerCase().includes(search.toLowerCase()));
      setList(filtered);
    } finally { setLoading(false); }
  };

  useEffect(() => { const t = setTimeout(load, 300); return () => clearTimeout(t); /* eslint-disable-next-line */ }, [search]);

  return (
    <div className="space-y-4" data-testid="followups-page">
      <div className="flex items-center gap-3">
        <div className="relative flex-1 max-w-md">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input data-testid="followups-search-input" placeholder="Cari client / invoice…" className="pl-9" value={search} onChange={(e) => setSearch(e.target.value)} />
        </div>
      </div>

      <Card className="bg-card border-border">
        <CardContent className="p-0">
          <div className="overflow-x-auto">
            <Table data-testid="followups-table">
              <TableHeader>
                <TableRow className="border-border hover:bg-transparent">
                  <TableHead>Tgl Follow-up</TableHead>
                  <TableHead>Client</TableHead>
                  <TableHead>Invoice</TableHead>
                  <TableHead>Channel</TableHead>
                  <TableHead>Hasil</TableHead>
                  <TableHead>Berikutnya</TableHead>
                  <TableHead></TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {loading && <TableRow><TableCell colSpan={7} className="text-center py-8 text-muted-foreground"><Loader2 className="inline h-4 w-4 animate-spin mr-2" />Memuat…</TableCell></TableRow>}
                {!loading && list.length === 0 && <TableRow><TableCell colSpan={7} className="text-center py-8 text-muted-foreground">Belum ada follow-up.</TableCell></TableRow>}
                {list.map(f => (
                  <TableRow key={f.id} className="hover:bg-white/4 border-border">
                    <TableCell>{formatDateID(f.follow_up_date)}</TableCell>
                    <TableCell className="font-medium">{f.client_name}</TableCell>
                    <TableCell className="font-mono-num text-xs">{f.invoice_number}</TableCell>
                    <TableCell>{CHANNEL_LABEL_ID[f.channel] || f.channel}</TableCell>
                    <TableCell className="text-muted-foreground truncate max-w-[320px]">{f.follow_up_result || '-'}</TableCell>
                    <TableCell>{formatDateID(f.next_follow_up_date)}</TableCell>
                    <TableCell>
                      {f.invoice_id ? <Button variant="ghost" size="icon" className="h-8 w-8" onClick={() => navigate(`/invoices/${f.invoice_id}`)}><Eye className="h-4 w-4" /></Button> : null}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
